// extracted by mini-css-extract-plugin
export default {"tariffs_buttons":"styles_tariffs_buttons__yqjjR"};